<template>
  <div class="answerDialog">
    <el-dialog :title="$lang('问题件回复')"
      custom-class="problem_dialog"
      :visible="visible"
      width="890px"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="closeDialog">
      <div class='collapse_box'>
        <div class="content">
          <el-collapse v-model="collapseActive" accordion>
            <el-collapse-item class="collapse_item" :title="$lang('问题件记录')" name="1">
              <div class="record_item">
                <div class="item">
                  <div class="commit-title">{{ $lang('登记时间') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.createTime || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('登记网点') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.registrationNetworkName || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('接受网点') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.receiveNetworkName || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('操作类型') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.probleTypeName || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('问题件类型') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.secondLevelTypeName || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('问题件原因') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.probleDescription || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('回复人') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.problemServiceRecordVOList &&  problemServiceInfo.problemServiceRecordVOList[0].createByName || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('回复时间') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.problemServiceRecordVOList &&  problemServiceInfo.problemServiceRecordVOList[0].createTime || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('回复内容') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.problemServiceRecordVOList &&  problemServiceInfo.problemServiceRecordVOList[0].replyContent || '--' }}</div>
                </div>
              </div>
              <div v-if="urls&&urls.length > 0">{{ $lang('问题件图片') }}:</div>
              <div class="img-ul"
                  v-if="urls&&urls.length > 0">
                <span class="img-li"
                      v-for="(url, index) in urls"
                      :key="index">
                  <img :src="url"
                      width="40"
                      height="40"
                      @click="handlePreview(url)" />
                </span>
              </div>
            </el-collapse-item>
            <el-collapse-item class="collapse_item" :title="$lang('回复记录')" name="2">
              <div class="al-req">
                <div class="alr-img">
                  <i class="el-icon-user-solid"></i>
                </div>
                <span style="padding-left: 6px;line-height: 20px;">{{ $lang('回复网点') }}-{{ problemServiceInfo.problemServiceRecordVOList &&  problemServiceInfo.problemServiceRecordVOList[0].replyNetworkName }}:</span>
              </div>
              <div class="record_item">
                <!-- <div class="item">
                  <div class="commit-title">{{ $lang('回复网点') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo && problemServiceInfo.replyNetworkName || '--' }}</div>
                </div> -->
                <div class="item">
                  <div class="commit-title">{{ $lang('回复人') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.problemServiceRecordVOList &&  problemServiceInfo.problemServiceRecordVOList[0].createByName || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('手机号码') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.problemServiceRecordVOList &&  problemServiceInfo.problemServiceRecordVOList[0].replyPhone || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('回复时间') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.problemServiceRecordVOList &&  problemServiceInfo.problemServiceRecordVOList[0].createTime || '--' }}</div>
                </div>
                <div class="item">
                  <div class="commit-title">{{ $lang('回复内容') }}:</div>
                  <div class="commit-content">{{ problemServiceInfo.problemServiceRecordVOList && problemServiceInfo.problemServiceRecordVOList[0].replyContent || '--' }}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="text-area">
            <el-input
              type="textarea"
              class="input-descri"
              :placeholder="$lang(placeholderText)"
              v-model="textarea"
              maxlength="500"
              show-word-limit
              :disabled="!hasBtn()"
              :rows="5"
            ></el-input>
          </div>
          <!-- <div class="upload-file">
            <el-button class="accessory">
              <i class="el-icon-paperclip"></i>
              <span style="cursor: pointer;">{{ $lang('添加附件') }}</span>
              <BaseUpload class="upload"
                :limit="10"
                :list="fileList"
                ref="upload"
                :option="{
                  projectName: 'css',
                  moduleName: 'problemPiece',
                  fileNames: 'payImgs'
                }"
                :fileTypeList="['jpg', 'jpeg', 'png']"
                :uploadData="uploadData"
                @uploadSuccess="uploadSuccess"
                @uploadError="uploadError"
                @uploadRemove="uploadRemove"
              ></BaseUpload>
            </el-button>
            <div class="imgs"
                 v-if="payImgs.length">
              <div class="title f1">{{ $lang('附件图片') }}:</div>
              <div class="f2">
                <span v-for="(ele, index) in payImgs"
                      :key="index"
                      style="padding-right: 15px;position: relative;">
                  <img :src="ele.url"
                       width="40"
                       height="40"
                       @click="handlePreview(ele.url)" />
                  <span @click="uploadRemove(ele, payImgs)"
                        class="closeSpan">
                    <i class="iconfont iconwuliao-bohui"></i>
                  </span>
                </span>
              </div>
            </div>
          </div> -->
        </div>
        <div class="footer">
          <el-button type="primary" :loading="loading" :disabled="false" @click="sumbit" v-if="hasBtn()">{{ $lang('回复') }}</el-button>
          <el-button @click="resetInput" v-if="hasBtn()">{{ $lang('重置') }}</el-button>
          <el-button @click="closeDialog">{{ $lang('取消') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <BaseImgPreView :visable.sync="preViewVisible"
                    :src.sync="preViewUrl"></BaseImgPreView>
  </div>
</template>

<script>
import { addVIPReply } from '@api/module/customer'
// import BaseUpload from './BaseUpload'
export default {
  name: 'EditProblem',
  components: {
    // BaseUpload
  },
  props: {
    problemServiceInfo: {
      type: Object,
      default: _ => {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      preViewVisible: false,
      collapseActive: '1',
      textarea: '',
      fileList: [],
      placeholderText: '',
      payImgs: [],
      uploadData: {
        moduleName: 'MSDM',
        fileType: 'transaction_vouchers',
        documentation: 'PROBLEM_SERVICE_RECORD',
        documentationId: ''
      },
      visible: false
    }
  },
  watch: {
    'problemServiceInfo': {
      deep: true,
      handler (newVal, oldVal) {
        console.log(newVal, 'newVal_____')
      },
    },
  },
  methods: {
    async showDialog(row) {
      this.visible = true
      this.collapseActive = '1'
    },
    // 提交回复
    async sumbit() {
      if (!this.textarea) {
        return
      }
      const params = {
        ids: [this.problemServiceInfo.id],
        clientRemark: this.textarea,
        attachmentEs: []
      }
      this.loading = true
      const res = await addVIPReply(params)
      if (res && res.succ) {
        this.loading = false
        this.textarea = ''
        this.$message.success(this.$lang('回复成功'))
        this.closeDialog()
      } else {
        this.loading = false
        this.$message.error(this.$lang(res.msg))
      }
    },
    // 上传成功回调
    uploadSuccess(res) {
      const $this = this
      this.fileList.push(res.res)

      this.payImgs = this.fileList.map(item => {
        $this.srcList.push(item.downloadUrl)
        return {
          id: item.id,
          url: item.downloadUrl,
          name: item.name
        }
      })
      //   console.log(this.payImgs)
    },
    // 附件删除
    uploadRemove(file, fileList) {
      this.fileList.forEach((element, index) => {
        if (file.id === element.id) this.fileList.splice(index, 1)
      })
      this.payImgs.forEach((ele, index) => {
        if (file.id === ele.id) this.payImgs.splice(index, 1)
      })
      // this.$refs.upload.$refs.upload.handleRemove()
    },
    // 重置
    resetInput() {
      this.textarea = ''
    },
    // 图片预览
    handlePreview: function (file) {
      this.preViewUrl = file
      this.preViewVisible = true
    },
    closeDialog() {
      this.visible = false
    },
    /*
     * isJmsReplyAvailable
     * JMS是否回复 1=是、2=否
     *
     * doesVipReply
     * vip是否已经回复 1=是、2=否
     */
    hasBtn() {
      if (this.problemServiceInfo) {
        const { doesVipReply = '' } = this.problemServiceInfo
        if (doesVipReply === 1) {
          this.placeholderText = '该问题件已回复'
          return false
        } else {
          this.placeholderText = '请输入'
          return true
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse_box{
  width: 100%;
  height: 560px;
  position: relative;
}

.al-req {
  margin-top: 20px;
  padding-bottom: 5px;
  display: flex;
  .alr-img {
    background: rgba(45, 124, 255, 0.1);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    text-align: -webkit-center;
    line-height: 20px;
  }
}

.content {
  height: 490px;
  overflow: auto;
}

.commit-title {
  color: #9499a3;
  font-size: 12px;
}

.commit-content {
  color: #61666d;
}

.record_item {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  .item {
    width: 33%;
  }
}

.upload-file {
  margin-top: 10px;
  .input-descri {
    margin-top: 20px;
  }

  .imgs {
    // width: 80%;
    position: absolute;
    .f1,
    .f2 {
      display: inline-block;
      vertical-align: text-top;
      padding-bottom: 10px;
    }
    .f2 {
      width: 80%;
      padding-left: 10px;
      .closeSpan {
        line-height: 12px;
        height: 12px;
        right: 5px;
        position: absolute;
        top: -30px;
        background: #666666;
        border-radius: 6px;
        color: white;
        cursor: pointer;
      }
    }
    a {
      display: inline-block;
      padding: 3px;
      font-size: 12px;
      text-decoration: none;
      position: relative;
      // color: $-color-brand;
      .el-icon-circle-close {
        font-size: 14px;
      }
      img {
        position: absolute;
        left: 0;
        top: 20px;
        display: none;
        z-index: 2;
      }
      i {
        color: #888;
      }
    }
    a:hover {
      text-decoration: underline;
      i {
        color: #333;
      }
      img {
        display: block;
      }
    }
  }
}
.text-area {
  margin-top: 10px;
}

.accessory {
  position: relative;

  .el-icon-paperclip {
    margin-right: 2px;
    vertical-align: middle;
  }
  .upload {
    height: 30px;
    overflow: hidden;
    opacity: 0;
    padding: 0;
    position: absolute;
    left: 0;
    top: 0;
  }
  .upload-list-picture-card {
    padding-top: 0;
    margin-top: 0;
  }
  .upload-list-item {
    display: none;
  }
  .upload-right {
    display: block;
    margin-right: 0;
  }
  // .upload-list-picture-card {
  //   display: none;
  // }
  font-size: 12px;
  // color: #69a1ff;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
}

.footer {
  margin-top: 20px;
}
::v-deep {
  .el-collapse-item__header {
    border-color: #dcdee1;
    background-color: #f2f2f2;
    padding-left: 10px;
  }
}
</style>

